export const API_CALL = {
  SUMMARY_API: (orgId) => `api/v1/expenses/subscriptions/summary?organisation_id=${orgId}`,
  SPEND_ANALYSIS_API: (orgId) => `api/v1/expenses/subscriptions/spend-analysis?organisation_id=${orgId}`,
  SUBSCRIPTION_LIST_API: (params) => `/ms/spm-organisation/v1/subscriptions/?${params.toString()}`,
};
